import React from 'react';
import { faFileLines } from '@fortawesome/pro-solid-svg-icons/faFileLines';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import IconMessageColumn from '../../../components/columns/icon-message-column';
import Global from '../../../store/global-selectors';

import { messages } from './messages';

/**
 * Component for displaying the packing slip printed status of a fulfillment plan.
 * @param {string} fulfillmentPlanId
 * @returns {JSX.Element}
 */
const PackingSlipPrintedColumn = ({ fulfillmentPlanId }) => {
  const packingSlipPrintedStatus = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'packingSlipPrintedStatus',
    }),
  );

  const { isPrinted, modifiedDateTime } = packingSlipPrintedStatus ?? {
    isPrinted: false,
    modifiedDateTime: null,
  };

  return (
    <IconMessageColumn
      date={modifiedDateTime}
      icon={faFileLines}
      message={<FormattedMessage {...messages.printed} />}
      state={isPrinted ? 'normal' : 'empty'}
      tooltipMessage={<FormattedMessage {...messages.packingSlipPrinted} />}
    />
  );
};

export const PackingSlipPrinted = {
  getMessageDescriptor: () => messages.packingSlipPrinted,
  id: 'packing-slip-printed',

  render: (data) => {
    return <PackingSlipPrintedColumn fulfillmentPlanId={data.id} />;
  },
};
